import { AdminNotesSection } from "fearless-common-ui";
import useGet from "../hooks/useGet";
import {backendEndpoints} from "../../libs/backendEndpoints";
import axios from "axios";
import {Note, User} from "fearless-common";
import useAuth from "../hooks/useAuth";


type NoteWithRelations = Note & {
  created_by: Pick<User, 'first_name' | 'last_name' | 'profile_picture' | 'id'>;
}

/**
 * Component view in which users can add notes to something. Pretty much like a comments section.
 *
 * @param type `noteable_type` column value to filter on in the API calls E.g. 'App\Models\User'
 * @param typeId The ID of the type.
 * @return {JSX.Element}
 * @constructor
 */
export default function AdminNotes({ type, typeId }: { type: string; typeId: number }) {
    const { user } = useAuth();
    const { data, reload } = useGet<NoteWithRelations[]>({
        endpoint: backendEndpoints.getAdminNotes,
        params: {
            noteable_type: type,
            noteable_id: typeId,
        },
    });

  return user ? (
    <>
      <h3>Notes for admin</h3>
      <p><small>Write down any notes for co-workers.</small></p>
      <AdminNotesSection
          // @ts-ignore
          notes={data || ([] as NoteWithRelations[])}
          currentUserId={user?.id}
          onSubmit={(values) => {
              return axios.post(backendEndpoints.postAdminNotes, {
                  ...values,
                  noteable_type: type,
                  noteable_id: typeId,
                  admin_only: 1,
              }).then((): true => {
                return true;
              }).finally(() => {
                  reload();
              });
          }}
      />
    </>
    ) : null;
}
